import { Input } from "@mui/material";
import axios from 'axios';
import React from "react";
import { hiddenInputSx } from '../common/styleUtil';
import attachmentService from './attachment.service';

export default function AttachmentInput(props) {
	const { attachableType, attachableId, onUpload, onSelect } = props;

	const uploadFile = async (file) => {
		if(!file){
			return;
		}
		const attachment = {
			attachableType: attachableType,
			attachableId: attachableId,
			fileName: file.name,
			fileType: file.type,
		};
		onSelect?.(attachment);

		let result = await attachmentService.preUpload(attachment);

		const url = result.data.data.url;
		const { pathname } = new URL(url);

		result = await axios.put(url, file, {
			headers: {
				'Content-Type': file.type,
			},
		});

		attachment.filePath = pathname.substring(1);

		result = await attachmentService.create(attachment);
		onUpload?.(result.data.data);
	};

	return (
		<Input sx={hiddenInputSx} type="file" onChange={(event) => uploadFile(event.target.files[0])} />
	);
}